// removed by extract-text-webpack-plugin
module.exports = {"detailsContainer":"styles__detailsContainer___20WTe","doneIcon":"styles__doneIcon___2takS"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/IncidentManager/components/AudioRequest/components/RequestDetailsModal/styles.css
// module id = 2847
// module chunks = 0